import { Alert, Divider, ListTitle } from "@components"
import { getDateRangeStatus, getSessionDateRange } from "@helpers"
import { PencilSquareIcon, Square3Stack3DIcon, TrashIcon } from "@heroicons/react/24/outline"
import { Button } from "@heroui/react"
import orderBy from "lodash/orderBy"
import PropTypes from "prop-types"

const SessionList = ({ 
  backButton, 
  event,
  handleCreateSession,
  handleDeleteSession,
  handleEditSession, 
  sessions 
}) => {
  const eventStatus = getDateRangeStatus(event.start_date, event.end_date, "milliseconds")
  const isNewButtonDisabled = eventStatus === "Expired" || eventStatus === "Current"

  return (
    <div>
      <div className="mb-6">
        {eventStatus === "Current" && (
          <Alert type="info" classNames="mb-4" title="Read Only Mode" description="Cannot create a session when the event is live." />
        )}

        {eventStatus === "Expired" && (
          <Alert type="info" classNames="mb-4" title="Read Only Mode" description="Cannot modify sessions as the event has expired." />
        )}

        {orderBy(sessions, ['starts_at'], ['asc']).map((session) => {
          const description = `${getSessionDateRange(session.starts_at, session.ends_at, "ddd Do MMM")}`
          const sessionStatus = getDateRangeStatus(session.starts_at, session.ends_at, "milliseconds")
          const isSessionDisabled = sessionStatus === "Expired" || sessionStatus === "Current"

          return (
            <div key={session.id}>
              <div className="flex items-center justify-between gap-3">
                <ListTitle description={description} icon={Square3Stack3DIcon} iconColor="text-indigo-600" title={session.title} />

                <div className="flex items-center gap-1">
                  <Button color="secondary" isIconOnly onPress={() => handleEditSession(session)} isDisabled={isSessionDisabled}>
                    <PencilSquareIcon className="w-6 h-6" />
                  </Button>

                  <Button color="danger" isIconOnly onPress={() => handleDeleteSession(session)} isDisabled={isSessionDisabled}>
                    <TrashIcon className="w-6 h-6" />
                  </Button>
                </div>
              </div>

              <Divider className="my-4" />
            </div>
          )
        })}
      </div>

      <Button className="font-semibold" color="secondary" isDisabled={isNewButtonDisabled} fullWidth onPress={() => handleCreateSession()}>Add Session</Button>
      {backButton}
    </div>
  )
}

SessionList.propTypes = {
  backButton: PropTypes.element.isRequired,
  event: PropTypes.object.isRequired,
  handleCreateSession: PropTypes.func.isRequired,
  handleDeleteSession: PropTypes.func.isRequired,
  handleEditSession: PropTypes.func.isRequired,
  sessions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    starts_at: PropTypes.string.isRequired,
    ends_at: PropTypes.string.isRequired,
  })).isRequired,
}

export default SessionList